import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { competencesService } from '@/services';
import { Providers, State } from './types';
import { FETCH_ITEMS, SET_ITEMS, SET_COUNT } from './consts';

const storeModule = ({ $api }: Providers) => {
  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class CompetencesListStore extends VuexModule<State, any> {
    items: Array<any> = [];
    count: number = 0;

    @Mutation
    [SET_ITEMS](items: any) {
      this.items = items;
    }

    @Mutation
    [SET_COUNT](value: any) {
      this.count = value;
    }

    @Action
    async [FETCH_ITEMS](params: any) {
      const { commit } = this.context;

      try {
        const { filtered, data } = await competencesService(
          $api,
        ).getCompetences(params);

        commit(SET_ITEMS, data);
        commit(SET_COUNT, filtered ? filtered : data.length);
      } catch (e) {}
    }
  }

  return CompetencesListStore;
};

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/competences/list/store.ts